<h1 mat-dialog-title>Request Resubmit for {{data.applicant.user.realName}}</h1>
<mat-dialog-content [formGroup]="form">
  <p class="intro">
    Select all of the reasons this {{data.applicant.user.upgradeRequested ? 'upgrade request' : 'application'}} needs to be resubmitted:
  </p>
  <p>
    <i>Identity</i>
  </p>
  <ul>
    <li><mat-checkbox formControlName="onePersonOnly">The application is for more than one person.</mat-checkbox></li>
    <li><mat-checkbox formControlName="insufficientIdentityInfo">There is insufficient information to find this person online.</mat-checkbox></li>
  </ul>
  <p>
    <i>Experience</i>
  </p>
  <ul>
    <li><mat-checkbox formControlName="insufficientGameCount">The user has not reported to have played enough rooms.</mat-checkbox></li>
    <li><mat-checkbox formControlName="insufficientExperienceInfo">There is insufficient evidence to support the room count.</mat-checkbox></li>
  </ul>
  <p>
   <i>Transparency</i>
  </p>
  <ul>
    <li><mat-checkbox formControlName="insufficientConflictDisclosure">There is insufficient disclosure of conflicts of interest.</mat-checkbox></li>
    <li><mat-checkbox formControlName="affiliationsNotInBio">The bio does not include affiliations by name.</mat-checkbox></li>
  </ul>
  <p>
    <i>Data Quality</i>
  </p>
  <ul>
    <li><mat-checkbox formControlName="invalidName">The user's name is invalid or not capitalized properly.</mat-checkbox></li>
    <li><mat-checkbox formControlName="invalidCity">The user's city is invalid or not capitalized properly.</mat-checkbox></li>
    <li>
      <mat-checkbox formControlName="invalidIds" (change)="onInvalidIdsChange()">One or more of the user's account IDs are invalid.</mat-checkbox>
      <ul *ngIf="form.value.invalidIds" class="nested-reasons">
        <ng-container formGroupName="invalidIdFields">
          <li *ngFor="let idField of visibleIdFields">
            <mat-checkbox [formControlName]="idField.field" (change)="onInvalidIdFieldChange()">
              {{ idField.label }}<span *ngIf="idField.value" class="id-value"> ({{ idField.value }})</span>
            </mat-checkbox>
          </li>
        </ng-container>
      </ul>
      <div *ngIf="invalidIdsNeedSelection" class="hint">Select which ID(s) are invalid.</div>
    </li>
    <li><mat-checkbox formControlName="insufficientBio">The bio needs to be improved or translated.</mat-checkbox></li>
  </ul>
  <p>
    <i>Other</i>
  </p>
  <ul>
    <li>
      <mat-checkbox formControlName="custom">Add custom instructions</mat-checkbox><br>
      <mat-form-field *ngIf="form.value.custom" appearance="fill">
        <mat-label>Custom instructions</mat-label>
        <textarea matInput formControlName="customInstructions" [disabled]="!form.value.custom"
                  cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="2"></textarea>
      </mat-form-field>
    </li>
    <li>
      <mat-checkbox formControlName="ccMe">CC me on the email</mat-checkbox>
    </li>
  </ul>
  <p class="preview-label">
    <i>Email preview</i>
  </p>
  <div class="email-preview">
    <div class="email-subject">Subject: {{ emailSubject }}</div>
    <div class="email-body" [innerHTML]="emailPreview"></div>
  </div>
</mat-dialog-content>
<div mat-dialog-actions align="end">
  <button mat-raised-button color="secondary" (click)="cancel()">
    Cancel
  </button>
  <button mat-raised-button color="primary" (click)="submit()" [disabled]="!formIsValid()">
    Submit
  </button>
</div>
